import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const BugIcon = (props: IconProps) => (
  <Icon fill="none" title={t`Bug`} viewBox="0 0 24 24" {...props}>
    <Path
      d="m8 2 2 2m6-2-2 2M9 7V6a3 3 0 0 1 6 0v1m-3 13c-3.314 0-6-2.686-6-6v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3c0 3.314-2.686 6-6 6Zm0 0v-9M6.5 9C4.5 8.5 3 7 2 5m4 8H2m1 8c.75-1.5 1.75-2.5 3.25-3.25M17.5 9c2-.5 3.5-2 4.5-4m-4 8h4m-1 8c-.75-1.5-1.75-2.5-3.25-3.25"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </Icon>
);
